import { Col, message, Row, Select } from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import { FormItem, RangePickerItem, SelectItem } from "../../../../Components/Items";

const { Option } = Select;

/**
 * Barra de filtros compartida por los cuatro reportes de Calidad.
 */
class FiltrosCalidad extends Component {
  state = {
    programas: [],
    procesos: [],
    colaboradores: [],
    programaSeleccionado: null,
    cargandoProgramas: false,
    cargandoColaboradores: false,
  };

  componentDidMount() {
    const { campos = [] } = this.props;
    if (campos.includes("programa")) this.cargarProgramas();
    if (campos.includes("colaborador")) this.cargarColaboradores();
  }

  cargarProgramas() {
    // valor 1 = solo programas activos (los deshabilitados no se ofrecen como filtro).
    this.setState({ cargandoProgramas: true });
    axios
      .post(
        "programa/listaProgramas",
        { empresaId: this.props.empresaId, valor: 1, page: 1, pageSize: 1000 },
        { headers: this.props.headersToken }
      )
      .then((res) => this.setState({ programas: res.data.data ?? [] }))
      .catch(() => message.error("No se pudieron cargar los programas"))
      .finally(() => this.setState({ cargandoProgramas: false }));
  }

  cargarColaboradores() {
    this.setState({ cargandoColaboradores: true });
    axios
      .post(
        "programa/listaEjecutoresCalidad",
        { empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => this.setState({ colaboradores: res.data.data ?? [] }))
      .catch(() => message.error("No se pudieron cargar los colaboradores"))
      .finally(() => this.setState({ cargandoColaboradores: false }));
  }

  cargarProcesos(programaId) {
    if (!programaId) {
      this.setState({ procesos: [] });
      return;
    }
    axios
      .post(
        "proceso/listaProcesos",
        { empresaId: this.props.empresaId, programaId, page: 1, pageSize: 1000 },
        { headers: this.props.headersToken }
      )
      .then((res) => this.setState({ procesos: res.data.data ?? [] }))
      .catch(() => message.error("No se pudieron cargar los procesos"));
  }

  onCambiarPrograma = (v) => {
    this.setState({ programaSeleccionado: v });
    // El proceso depende del programa: al cambiarlo hay que limpiar la selección previa
    this.props.formRef?.current?.setFieldsValue({ procesoId: undefined });
    if (this.props.campos?.includes("proceso")) this.cargarProcesos(v);
  };

  render() {
    const { campos = [], requeridos = [] } = this.props;
    const esReq = (nombre) => requeridos.includes(nombre);

    const md = campos.length <= 2 ? 8 : campos.length === 3 ? 8 : 6;

    return (
      <div className="cal-filtros">
        <Row gutter={[12, 0]}>
          {campos.includes("periodo") && (
            <Col xs={24} sm={12} md={md}>
              <FormItem label="Período" name="periodo" margin required={esReq("periodo")}>
                <RangePickerItem />
              </FormItem>
            </Col>
          )}

          {campos.includes("programa") && (
            <Col xs={24} sm={12} md={md}>
              <FormItem
                label="Programa"
                name="programaId"
                margin
                required={esReq("programaId")}
              >
                <SelectItem
                  placeholder={esReq("programaId") ? "Elige un programa" : "Todos los programas"}
                  allowClear={!esReq("programaId")}
                  onChange={this.onCambiarPrograma}
                  mostrarCarga
                  loading={this.state.cargandoProgramas}
                  notFoundContent={
                    this.state.cargandoProgramas
                      ? "Cargando programas…"
                      : "No hay programas registrados en esta empresa"
                  }
                >
                  {this.state.programas.map((p) => (
                    <Option key={p._id} value={p._id}>
                      {p.nombre}
                    </Option>
                  ))}
                </SelectItem>
              </FormItem>
            </Col>
          )}

          {campos.includes("proceso") && (
            <Col xs={24} sm={12} md={md}>
              <FormItem
                label="Proceso"
                name="procesoId"
                margin
                required={esReq("procesoId")}
              >
                <SelectItem
                  placeholder={
                    esReq("procesoId")
                      ? this.state.programaSeleccionado
                        ? "Elige un proceso"
                        : "Elige primero un programa"
                      : "Todos los procesos"
                  }
                  allowClear={!esReq("procesoId")}
                  disabled={!this.state.programaSeleccionado}
                  notFoundContent="Este programa no tiene procesos"
                >
                  {this.state.procesos.map((p) => (
                    <Option key={p._id} value={p._id}>
                      {p.nombre}
                    </Option>
                  ))}
                </SelectItem>
              </FormItem>
            </Col>
          )}

          {campos.includes("colaborador") && (
            <Col xs={24} sm={12} md={md}>
              <FormItem
                label="Colaborador"
                name="ejecutadoPor"
                margin
                required={esReq("ejecutadoPor")}
              >
                <SelectItem
                  placeholder={
                    esReq("ejecutadoPor") ? "Elige un colaborador" : "Todos los colaboradores"
                  }
                  allowClear={!esReq("ejecutadoPor")}
                  mostrarCarga
                  loading={this.state.cargandoColaboradores}
                  notFoundContent={
                    this.state.cargandoColaboradores
                      ? "Cargando colaboradores…"
                      : "Ningún registro de calidad tiene colaborador asignado (RegistroProceso.ejecutadoPor)"
                  }
                >
                  {this.state.colaboradores.map((c) => (
                    <Option key={c._id} value={c._id}>
                      {c.nombre}
                    </Option>
                  ))}
                </SelectItem>
              </FormItem>
            </Col>
          )}

          {campos.includes("resultado") && (
            <Col xs={24} sm={12} md={md}>
              <FormItem label="Resultado" name="resultado" margin>
                <SelectItem placeholder="Todos" allowClear>
                  <Option value="completado">Completado</Option>
                  <Option value="completado_con_observaciones">Con observaciones</Option>
                  <Option value="rechazado">Rechazado</Option>
                  <Option value="pendiente">Pendiente</Option>
                </SelectItem>
              </FormItem>
            </Col>
          )}
        </Row>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
  empresaId: state.empresa.id,
});

export default connect(mapStateToProps)(FiltrosCalidad);
